import { render, staticRenderFns } from "./PaymentAttachPop.vue?vue&type=template&id=9463b958"
import script from "./PaymentAttachPop.vue?vue&type=script&lang=js"
export * from "./PaymentAttachPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9463b958')) {
      api.createRecord('9463b958', component.options)
    } else {
      api.reload('9463b958', component.options)
    }
    module.hot.accept("./PaymentAttachPop.vue?vue&type=template&id=9463b958", function () {
      api.rerender('9463b958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/PaymentAttachPop.vue"
export default component.exports